import React from "react"
import { IconColorsType } from "../"
import { camelize } from "../../utils"
import cx from "classnames"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "messages"
const MessagesIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    }
  )
  const wrap = (content: React.ReactNode) => (
    <span className={computedClassName}>{content}</span>
  )
  return wrap(
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 7V4.998c0-.551.456-.998 1.002-.998h9.995A1 1 0 0 1 22 4.998v7.004c0 .551-.456.998-1.003.998H20v2.5a.75.75 0 0 1-1.28.53L16 13.31V9.999A3 3 0 0 0 12.998 7H10ZM4 18h-.998A1 1 0 0 1 2 17.003V9.998C2 9.447 2.456 9 3.002 9h9.995A1 1 0 0 1 14 9.998v7.005c0 .55-.456.997-1.002.997H8.31l-3.03 3.03A.75.75 0 0 1 4 20.5V18Z"
      />
    </svg>
  )
}
export default MessagesIcon
